export default "__VITE_ASSET__iOWTIjTu__"